import { gaEvent } from 'src/utils'

/**
 * [TARGET]: No clique do ícone de ajuda no campo do "CVV" (código de segurança) para abrir o modal
 *
 * [CONTEXTO]: No link de pagamento, no formulário de cartão de crédito possui um campo de "CVV" (código de segurança) e um ícone de ajuda para explicar ao usuário mais detalhes.
 *
 * [REGRAS]: n/a
 *
 */
export const viewCardCVVModalEvent = () => {
  const event = {
    event: 'event',
    'event-category': `pagamentos-sellout:cartao-de-credito`,
    'event-action': 'view:modal',
    'event-label': 'cvv',
  }

  gaEvent(event)
}
